export const DEFAULT_BAGGAGE = {
  name: 'Objeto personal',
  value: 'backpack_baggage',
};

export const HAND_BAGGAGE = {
  name: 'Equipaje de mano',
  value: 'hand_baggage',
};

export const HOLD_BAGGAGE = {
  name: 'Equipaje de bodega',
  value: 'baggage_hold',
};

export const baggageRules = {
  hand_baggage: option =>
    option?.flight_baggage?.hand_baggage ||
    option?.flight_baggage?.baggage_hold,
  baggage_hold: option => option?.flight_baggage?.baggage_hold,
};

export const baggageDefinitions = {
  hand_baggage: { label: 'Equipaje de mano' },
  baggage_hold: { label: 'Equipaje de bodega' },
};
